export default __webpack_public_path__ + "static/behavioral-cohorts-dark-mode-5132c999e7b8fcb37936320ca79d6422.png";